import * as angular from 'angular';

import {react2angular} from "react2angular";

import LoginHelp from "../components/LoginHelp";

const ngModule = angular.module('reactLoginHelpModule', [])
    .component('reactLoginHelp', react2angular(LoginHelp));

const reactLoginHelpModuleName = ngModule.name;
export default reactLoginHelpModuleName;
